export default __webpack_public_path__ + "static/media/O-087.50ccf1bc.png";